/**
 * 品牌/域名配置模块
 * 通过后端 /api/brand 接口获取当前版本的域名信息
 */

export interface BrandConfig {
  edition: string;
  domain: string;
  opsDomain: string;
  dlDomain: string;
  opsURL: string;
  docsURL: string;
  dlURL: string;
  supportEmail: string;
  copyright: string;
  productName: string;
}

const defaults: BrandConfig = {
  edition: 'cn',
  domain: 'pidoc.cn',
  opsDomain: 'ops.pidoc.cn',
  dlDomain: 'dl.pidoc.cn',
  opsURL: 'https://ops.pidoc.cn',
  docsURL: 'https://pidoc.cn',
  dlURL: 'https://dl.pidoc.cn',
  supportEmail: 'support@pidoc.cn',
  copyright: 'pidoc.cn',
  productName: 'Pi Device Operations Connector',
};

export const PidocBrand: BrandConfig & { load: () => Promise<void> } = {
  ...defaults,
  async load() {
    try {
      const apiBase = window.API_BASE ?? `${window.location.origin}/api`;
      const resp = await fetch(`${apiBase}/brand`);
      if (resp.ok) {
        const data = (await resp.json()) as Partial<BrandConfig>;
        Object.assign(this, data);
      }
    } catch (e) {
      console.warn('[Brand] 获取品牌配置失败，使用默认值:', (e as Error).message);
    }
  },
};

// 自动加载
void PidocBrand.load();

// 兼容层
declare global {
  interface Window {
    PidocBrand?: typeof PidocBrand;
  }
}
window.PidocBrand = PidocBrand;
